import { z } from "zod";

export const getUserRolesEditFormModelSchema = () => {
	return z.object({
		name: z.string().nullish(),
		permissions: z.array(z.string()).nullish(),
	});
};

export type UserRolesEditFormModel = z.infer<
	ReturnType<typeof getUserRolesEditFormModelSchema>
>;
